import { NoMatchPage } from './404-page.component';

export const NoMatchPageContainer = () => {
  return <NoMatchPage />;
};
